import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getClients} from "../../store/reducers/ClientsSlice";
import Pagination from "../common/Pagination";
import {getOrders} from "../../store/reducers/OrdersSlice";
import CheckerSearch from "./components/CheckerSearch";
import {CheckerTable} from "./components/CheckerTable";
import {getChecker} from "../../store/reducers/CheckerSlice";

interface CheckerScreenProps {
    type: string
}

export const CheckerScreen: React.FC<CheckerScreenProps> = (props) => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const { type } = props;

    const perPage = parseInt(new URLSearchParams(window.location.search).get('perPage') || '80', 10);

    useEffect(() => {
       dispatch(getChecker(type));
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={true}>
            <CheckerSearch type={type} />
            <CheckerTable type={type} />
        </LoggedInView>
    )
}

